import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useBillInsuranceActivationSchema = () => {
  const { t } = useTranslation();

  return z.object({
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    phone: z.string(),
    jointBillServiceId: z.number(),
    dateOfBirth: z.date({
      required_error: t("common.form.field.errors.required"),
      invalid_type_error: t("common.form.field.errors.required"),
    }),
    billInsuranceTerms: z
      .boolean({ required_error: t("common.form.field.errors.required") })
      .refine((value) => value === true, {
        message: t("common.form.field.errors.required"),
      }),
    dataTransferToBillInsurer: z
      .boolean({ required_error: t("common.form.field.errors.required") })
      .refine((value) => value === true, {
        message: t("common.form.field.errors.required"),
      }),
  });
};

export type TBillInsuranceActivationSchema = z.infer<
  ReturnType<typeof useBillInsuranceActivationSchema>
>;
